import { gql } from "@stadium/services/apollo-client";
import { BUNDLE_PRODUCT_DETAILS } from "@graphql/fragments/product/kit-product-details";

export const populateBundleItems = gql`
  mutation PopulateBundleItems($input: PopulateBundleInput!) {
    populateBundle(input: $input) {
      bundle {
        id
        bundleProducts {
          ...BundleProductDetails
        }
      }
      error
    }
  }
  ${BUNDLE_PRODUCT_DETAILS}
`;
